export default __webpack_public_path__ + "static/media/driveonholidays-logo.df52a4df.png";